<template>
	<div class="up_grade">
		<div v-wechat-title="$route.meta.title"></div>
		<TopBar></TopBar>
		<div style="display: flex; justify-content: center; margin-top: 0px;">
			<div class="up_grade_left">
				<div style="color: #515A6E; font-weight: bold;">账号特权</div>
				<div style="display: flex; justify-content: center;margin-top: 50px;">
					<div class="team">
						<div class="user_img icon iconfont icon-huiyuan21"></div>
						<div style="margin-top: 30px; font-size: 18px; color: #27C1C9; margin-bottom: 10px;">个人版</div>
						<div><span style="font-size: 35px;font-weight: bold;margin-right: 5px;">￥0</span>/人/年</div>
						<div style="margin-top: 10px;">限1人使用</div>
						<div style="width: 200px;border-top: 1px solid #DDDDDD; margin: 30px 0;"></div>
						<div v-for="(item,index) in personage" :key="index" style="margin: 15px 0;">
							<span style="font-size: 15px; color: #5AB1FF;" class="icon iconfont icon-duihao"></span>
							<span style="margin-left: 10px; color: #727D8A;">{{item}}</span>
						</div>
						<div style="display: flex;">
							<span style="font-size: 15px; color: #5AB1FF;" class="icon iconfont icon-duihao"></span>
							<span style="margin-left: 10px; color: #727D8A;">
								<div>线索拓展平台</div>
								<div>可联系平台帮助律师获取付费推广线索</div>
							</span>
						</div>
					</div>
					<div class="team">
						<div class="team_img icon iconfont icon-zu"></div>
						<div style="margin-top: 30px; font-size: 18px; color: #008AFF; margin-bottom: 10px;">团队版(当前特权)
						</div>
						<div><span style="font-size: 35px;font-weight: bold;margin-right: 5px;">￥{{team.team_per_fee}}</span>/人/年</div>
						<div style="color: #DDDDDD;text-decoration:line-through;">原价{{config.vip_origin_price}}元/人/年</div>
						<div style="">限1人使用</div>
						<div style="width: 200px;border-top: 1px solid #DDDDDD; margin: 20px 0;"></div>
						<div v-for="(item,index) in teamList" :key="index" style="margin: 15px 0;">
							<span style="font-size: 15px; color: #5AB1FF;" class="icon iconfont icon-duihao"></span>
							<span style="margin-left: 10px; color: #727D8A;">{{item}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="up_grade_right">
				<div style="display: flex;justify-content: space-between;">
					<div style="color: #515A6E; font-weight: bold;">账号状态</div>
					<div class="record" @click="orderClick">下单记录<span style="font-size: 13px;"
																	  class="icon iconfont icon-z043"></span></div>
				</div>
				<div class="state_margin">
					<span>当前版本：</span>
					<span>{{config.name}}团队版</span>
					<span @click="refreshClick"
						  style="font-size: 15px; color: #008AFF; margin-left: 5px; cursor: pointer;"
						  class="icon iconfont icon-shuaxin"></span>
				</div>
				<div class="state_margin">
					<span>团队名称：</span>
					<span v-show="teamNameShow">{{team.name}}</span>
					<span v-show="teamNameShow" @click="editTeamClick"
						  style="font-size: 15px; color: #008AFF; margin-left: 5px; cursor: pointer;"
						  class="icon iconfont icon-bianji1"></span>
					<Input v-show="!teamNameShow" v-model="team.name" placeholder="请输入团队名称" style="width: 100px"/>
					<span v-show="!teamNameShow" style="color: #277dd3; cursor: pointer;margin-left: 5px;"
						  @click="saveTeamClick">保存</span>
				</div>
				<div class="state_margin">
					<span>有效期至：</span>
					<span>{{team.expired_at}}</span>
				</div>
				<div class="state_margin" style="display: flex; align-items: center; justify-content: space-between;">
					<div style="display: flex;">
						<span>使用情况：</span>
						<div>
							<div>可用名额：{{team.team_nums}}</div>
							<div>剩余可用名额：{{team.team_nums_left}}</div>
						</div>
					</div>
					<i-circle :percent="team.team_nums_percent" :size="70">
						<span class="demo-Circle-inner" style="font-size:15px">{{team.team_nums_percent}}%</span>
					</i-circle>
				</div>
				<div style="display: flex; width: 200px;justify-content: space-between;">
					<Button style="border-radius: 30px;" type="primary" @click="buyQuantityClick">名额扩容</Button>
					<Button style="border-radius: 30px;" type="primary" @click='buyTimeClick'>购买年数</Button>
				</div>
				<div style="margin-top: 30px;">若您对名额购买有任何疑问，可联系客服微信：{{config.service_wx}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import TopBar from '../topbar/TopBar.vue'
	import {mapGetters} from "vuex";
	import {getUpgrade} from "../../api/user";
	export default{
		name:"UpGrade",
		components:{TopBar},
		data() {
			return {
				team: {},
				teamName:'品伦律师',
				teamNameShow:true,
				personage:['日历面板','简单易操作的案件管理'],
				teamList:['个人版的全部功能','团队间任务协作','易于配置的权限模块','易上手的财务模块','律师个人账户管理','7*12小时专属技术顾问']
			}
		},
		computed:{
			...mapGetters(['token', 'config', 'userInfo']),
		},
		mounted() {
			this.loadData();
		},
		methods:{
			async loadData() {
				let that = this;
				let data = {
					token: that.token,
				};
				let res = await getUpgrade(that, data);
				if (res.code == 1) {
					that.team = res.data.team;
				}
			},
			editTeamClick() {
				this.teamNameShow = false
			},
			saveTeamClick() {
				this.teamNameShow = true
			},
			// 刷新
			refreshClick() {
				this.$router.go(0)
			},
			// 名额扩容
			buyQuantityClick() {
				this.$router.push('/buyquantity?type=1')
			},
			// 购买期限
			buyTimeClick() {
				this.$router.push('/buyquantity?type=2')
			},
			// 下单记录
			orderClick() {
				this.$router.push('/order')
			}
		}
	}
</script>

<style scoped lang="less">
	.up_grade{
		min-width: 1000px;
		height: 100%;
		background-color:#F5F7F9 ;
	}
	.up_grade_left{
		width: 1050px;
		height: 650px;
		background-color: #FFFFFF;
		border-radius: 5px;
		padding: 20px;
	}
	.up_grade_right{
		width: 560px;
		height: 650px;
		background-color: #FFFFFF;
		margin-left: 10px;
		border-radius: 5px;
		padding: 20px;
	}
	.team{
		height: 470px;
		width: 250px;
		background-color: #FFFFFF;
		box-shadow:  0 0 5px 3px rgba(0,0,0,0.1);
		margin: 0 40px;
		position: relative;
		padding: 20px;
	}
	.user_img{
		font-size: 40px;
		color: #27C1C9;
		position: absolute;
		left: 30px;
		top: -30px;
	}
	.team_img{
		font-size: 40px;
		color: #008AFF;
		position: absolute;
		left: 30px;
		top: -30px;
	}
	.record{
		color: #515A6E;
		span{
			color: #DDDDDD;
		}
	}
	.record:hover{
		cursor: pointer;
		color: #008AFF;
		span{
			color: #008AFF;
		}
	}
	.state_margin{
		margin: 20px 0;
	}
</style>
